import {Fragment} from 'react'
import FormikTextField from 'shared/FormikTextField'
import LabelAdder from './LabelAdder'
import './index.scss'
import {Box} from '@mui/material'
import FormikPhone from 'shared/FormikPhone'

interface InfoGroupProps {
    formik?: any
    isAuthenticated?: boolean
    phoneCode?: string
}

const InfoGroup = ({
    formik,
    isAuthenticated,
    phoneCode
}: InfoGroupProps) => (
    <Fragment>
        <LabelAdder
            id='name'
            label='Full Name'
            showAsterik={true}
            input={
                <FormikTextField
                    formik={formik}
                    id='name'
                    fullWidth
                    placeholder='First and Last Name'
                    className='contact_input'
                    maxLength={50}
                    disabled={isAuthenticated}
                />
            }
        />
        <Box className='side-by-side'>
            <LabelAdder
                id='phone'
                label='Phone'
                showAsterik={true}
                input={
                    <FormikPhone
                        id='phone'
                        flagId='countryCode'
                        formik={formik}
                        defaultCode={phoneCode}
                        maxLength={18}
                    />
                }
            />
            <LabelAdder
                id='email'
                label='Email'
                showAsterik={true}
                input={
                    <FormikTextField
                        formik={formik}
                        id='email'
                        typeHTML='email'
                        fullWidth
                        placeholder='name@example.com'
                        className='contact_input'
                        disabled={isAuthenticated}
                        maxLength={49}
                    />
                }
            />
        </Box>
    </Fragment>
)

InfoGroup.defaultProps = {
    isAuthenticated: false
}

export default InfoGroup
